import React from "react";
import { LinkButton } from "../../misc/LinkButton/LinkButton";
import { Icomoon, Icon } from "../../brand/Icon/Icon";
import "./StickyWidget.scss";

interface Props {

  /**
   * Heading text
   */
  heading: string;

  /**
   * Bullet points
   */
  bullets: string[];

  /**
   * Link
   */
  label: string;
  to: string;
}

/**
 * Sticky widget that floats on pages to alert or remind users of something important and timely
 * 
 * @status development
 */
export const StickyWidget: React.FC<Props> = ({ heading, bullets, label, to }) => {

  return (
    <div className="sticky-widget">

      <div className="sticky-widget__inner">

        <h4 className="sticky-widget__heading">{heading}</h4>
        <ul className="sticky-widget__bullets">
          {bullets.map(bullet => <li key={bullet}><Icon icomoon={Icomoon.checkmark3} />{bullet}</li>)}
        </ul>
        <LinkButton
          buttonClass="secondary-button"
          className=""
          iconAlign="left"
          target="_blank"
          to={to}
        >
          {label}
        </LinkButton>

      </div>

    </div>
  );
};
